<template>
  <div :style="style">
    <v-chip
      v-show="item.show !== false"
      v-for="item in list"
      :key="item.value"
      small
      :color="getColor(item)"
      class="pa-1"
      style="margin: 1px 1px"
      @click.native="onClick(item)"
    >
      {{ item.text }}</v-chip
    >
  </div>
</template>

<script>
import { modelOptions } from "./../../../mixings";

export default {
  mixins: [modelOptions],
  props: {
    value: [String, Number],
    values: [Object],
    model: {
      type: Object,
      default: {},
    },
  },
  computed: {
    list() {
      let list = JSON.parse(JSON.stringify(this.getOptions(this.model) || []));
      return list.filter((l) => {
        return this.value && this.value.toString(2).bin2array().includes(l.value);
      });
    },
    background() {
      let text = this.getElementByValue(this.value, this.model);
      return text?.bgColor ? "background-color:" + text.bgColor : "";
    },
    style() {
      let style = "";
      if (this.model?.style) style = this.model?.style;
      return style;
    },
  },
  methods: {
    getColor(item) {
      if (item.colorFunc) {
        try {
          let f = eval(`(values)=>{${item.colorFunc}}`);
          return f(this.values) || "primary";
        } catch (error) {}
      }
      return "primary";
      const log = this.logs[item.value];

      if (!log) return "grey";

      // CIAN
      if (log.errors && log.errors.length) return "red";
      if (log.warnings && log.warnings.length) return "orange";

      // AVITO
      if (log.messages) {
        if (log.messages.some((m) => m.type === "error")) return "red";
        if (log.messages.some((m) => m.type === "warning")) return "orange";
      }

      return "green";
    },

    onClick(item) {
      if (!item?.canClick) return;
      this.$emit("clickItem", item);
    },
  },
};
</script>
